import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { isNil } from 'lodash';
import { connect } from 'react-redux';
import cc from 'classcat';
import Banner from 'modules/Banner';
import onIdle from 'lib/onIdle';
import RouterLink from 'components/RouterLink';
import withLazyStyle from 'components/LazyStyle';
import style from './banner.css?lazy';

const CLICK_MAX_DELAY = 250;

class Vertical extends Component {
  _dispatchAction = () => {
    const { dispatchAction, actions } = this.props;

    if (actions) {
      actions.map((_action) => dispatchAction(_action));
    }
  };

  dispatchAction = () => {
    onIdle(this._dispatchAction, { timeout: CLICK_MAX_DELAY });
  };

  render() {
    const { background, backgroundType, destinationUrl, foreground, actions, className } =
      this.props;
    const isImage = backgroundType?.startsWith('image');
    const isVideo = backgroundType?.startsWith('video');
    if (!background) return false;
    const bannerClassName = cc({
      banner: true,
      'banner--actions': actions,
      [className]: className
    });
    return (
      <RouterLink className={bannerClassName} href={destinationUrl} onClick={this.dispatchAction}>
        {isVideo && (
          // eslint-disable-next-line jsx-a11y/media-has-caption
          <video
            key={background}
            className="banner__background"
            controls={false}
            autoPlay
            loop
            muted
            playsInline
          >
            <source src={background} type="video/mp4" />
          </video>
        )}
        {isImage && <img className="banner__background" src={background} alt="Vertical banner" />}
        {foreground && (
          // eslint-disable-next-line react/no-danger
          <div className="banner__foreground" dangerouslySetInnerHTML={{ __html: foreground }} />
        )}
      </RouterLink>
    );
  }
}

Vertical.propTypes = {
  className: PropTypes.string,
  actions: PropTypes.array,
  background: PropTypes.string,
  backgroundType: PropTypes.string,
  destinationUrl: PropTypes.string,
  foreground: PropTypes.string,
  dispatchAction: PropTypes.func.isRequired
};

Vertical.defaultProps = {
  className: null,
  actions: null,
  background: null,
  backgroundType: null,
  destinationUrl: null,
  foreground: null
};

const mapStateToProps = (state, ownProps) => {
  let banner = Banner.selectors.getBannerByName(state, ownProps.bannerName);

  if (banner && !isNil(ownProps.bannerStep)) {
    banner = banner[ownProps.bannerStep];
  }
  if (banner) {
    const { actions, background, backgroundType, destinationUrl, foreground, termsAndConditions } =
      banner;
    return {
      actions,
      background,
      backgroundType,
      destinationUrl,
      foreground,
      termsAndConditions
    };
  }
  return {};
};

const mapDispatchToProps = (dispatch) => ({
  dispatchAction: (action) => {
    dispatch(action);
  }
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withLazyStyle(style)
)(Vertical);
